import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";

const AddCategoryRateDialog = ({
  open,
  trainerId,
  availableCategories,
  onClose,
  onAdd,
}) => {
  const [categoryId, setCategoryId] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");

  const handleClose = () => {
    setCategoryId("");
    setHourlyRate("");
    onClose();
  };

  const handleAdd = async () => {
    const success = await onAdd(trainerId, categoryId, hourlyRate);
    if (success) {
      handleClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Dodaj stawkę dla kategorii</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          <FormControl fullWidth size="small">
            <InputLabel>Kategoria zajęć</InputLabel>
            <Select
              value={categoryId}
              label="Kategoria zajęć"
              onChange={(e) => setCategoryId(e.target.value)}
            >
              {availableCategories.map((cat) => (
                <MenuItem key={cat.id} value={cat.id}>
                  {cat.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Stawka godzinowa"
            type="number"
            size="small"
            fullWidth
            value={hourlyRate}
            onChange={(e) => setHourlyRate(e.target.value)}
            InputProps={{
              endAdornment: <InputAdornment position="end">PLN</InputAdornment>,
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Anuluj</Button>
        <Button variant="contained" onClick={handleAdd}>
          Dodaj
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCategoryRateDialog;
